import { RootState } from 'editor/src/store/index';

const getIsFocusedMediaElementSelector = (state: RootState, elementId: number) =>
  state.editor.focusedMediaElementUuid === elementId;

export default getIsFocusedMediaElementSelector;
